import type { WeeklyBlock } from '@/types/availability'

interface BlockErrors {
  start?: string
  end?: string
  range?: string
  overlap?: string
}

export function validateBlock(block: WeeklyBlock, others: WeeklyBlock[]): BlockErrors {
  const errors: BlockErrors = {}
  if (!block.start_time) errors.start = 'Start required'
  if (!block.end_time) errors.end = 'End required'
  if (block.start_time && block.end_time && block.start_time >= block.end_time) {
    errors.range = 'Start must be before end'
  }
  const sameDay = others.filter((b) => b.weekday === block.weekday && b.id !== block.id)
  const overlaps = sameDay.some(
    (b) => !(block.end_time <= b.start_time || block.start_time >= b.end_time),
  )
  if (overlaps) errors.overlap = 'Overlaps another block'
  return errors
}

export function hasWeeklyBlockErrors(blocks: WeeklyBlock[]): boolean {
  return blocks.some((b) => {
    const errors = validateBlock(b, blocks)
    return Boolean(errors.range || errors.overlap || errors.start || errors.end)
  })
}

export function detectBrowserTimezone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone
}
